import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import AdminDashboard from './admin/admin'; // Update path as needed
import ProtectedRoute from './ProtectedRoute';
const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
const isAdmin = localStorage.getItem('isAdmin') === 'true';
ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route
        path="/admin-dashboard"
        element={
          <ProtectedRoute isAllowed={isLoggedIn && isAdmin} redirectPath="/">
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  </BrowserRouter>
);
